module.exports = __webpack_public_path__ + "img/制御工学8_2.a3f97847.png";